import { render } from "./ManagedIT.vue?vue&type=template&id=63462697"
import script from "./ManagedIT.vue?vue&type=script&lang=js"
export * from "./ManagedIT.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__